import React from "react";
import "./Night.sass";
import frens from "./../../../assets/images/night-fren.png";
import frensMobi from "./../../../assets/images/night-mobile-fren.png";
import elon from "./../../../assets/images/elon.png";
import insignia from "./../../../assets/images/insignia.png";
import nighMachine from "./../../../assets/images/nigh-machine.png";

export default function Night() {
  return (
    <div className="night">
      <div className="night-bg">
        <div className="night-container">
          <div className="night-title">
            <h2>
              <span>
                One night <br className="mobile" />
              </span>
              after enjoying some divine OG Kush, <strong>Uncle Elon</strong>{" "}
              had the most fascinating dream. In this dream a Mystical Frog
              gifted Uncle Elon Emerald Tablets.
            </h2>
            <div className="night-insignia mobile">
              <img src={insignia} alt="frens dreaming" />
            </div>
          </div>
          <div className="night-frens">
            <img src={frens} className="not-mobile" alt="frens dreaming" />
            <img src={frensMobi} className="mobile" alt="frens dreaming" />
          </div>
          <div className="night-elon">
            <img src={elon} alt="elon" />
          </div>
          <div className="night-magical">
            On these Magical Tables were plans to create a{" "}
            <strong>Dream Machine.</strong> Uncle Elon did not know the exact
            reason for the Machine, but he knew it had a higher purpose, so he
            got to work right away. He worked day and night for 77 days until
            the Machine was finally completed.
          </div>
          <div className="night-footer">
            <h2>
              Once complete he realized the Machine had Two components: the
              frENGINE and the degENGINE. Perplexed by this he Memed to Kek for
              Guidance. Kek came to Uncle Elon through the power of repeating
              digits and told Uncle Elon this Machine created with his beautiful
              technology would be powered by <strong>TENDIES</strong> and
              protect the Frens from the Wage Cage Forever. Uncle Elon then
              understood Kek was the Holy TENDIES of Eternal Gains, he that
              cometh to Kek shall never Wage Slave or WageCuck again. Upon this
              revelation, Kek honored Elon with the glorious title “Technoking”.
            </h2>
            <div className="night-machine mobile">
              <img src={nighMachine} alt="machine dreaming" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
